import ModalShell from "./ModalShell.jsx";

export default function VideoUploadStatus({ uploading, progress, completed, onCancel, onClose }) {
  if (!uploading) return null;

  return (
    <ModalShell onClose={completed ? onClose : null}>
      {completed ? (
        <>
          <h3>✅ Upload Complete!</h3>
          <button onClick={onClose}>OK</button>
        </>
      ) : (
        <>
          <h3>Uploading Video...</h3>
          <div className="upload-wrapper">
            <div 
              className="progressBar" 
              style={{ width: `${progress}%` }}>
            </div>
          </div>
          <p>{progress}%</p>
          <button onClick={onCancel}>Cancel</button>
        </>
      )}
    </ModalShell>
  );
}
